/**
 * VIS Contact Form Fields.
 * @format
 */
import { specialtyList } from '../../form-components/lists/specialty-list';

const visFunctionalRoles = [
  { name: 'Physician', value: 'VIS Physician' },
  { name: 'Other', value: 'Other' },
];

export const visContactFormFields = [
  {
    fieldTitle: 'First name',
    fieldName: 'FirstName',
    id: 'fname',
    type: 'text',
    placeholderText: 'Your first name here',
    errorMessage: 'First Name field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Last name',
    fieldName: 'LastName',
    id: 'lname',
    type: 'text',
    placeholderText: 'Your last name here',
    errorMessage: 'Last Name field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Email address',
    fieldName: 'Email',
    id: 'email',
    type: 'email',
    placeholderText: 'name@website.com',
    errorMessage: 'Invalid email.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Company Name',
    fieldName: 'Company',
    id: 'organization',
    type: 'text',
    placeholderText: "Your company's name",
    errorMessage: 'Company name field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Functional role',
    fieldName: 'Functional_role__c',
    id: 'functional-role-select',
    type: 'select',
    placeholderText: 'Select a role',
    errorMessage: 'Functional role field required.',
    required: true,
    list: visFunctionalRoles,
    useNameAsLookupValue: false,
    parentItems: [{ value: 'VIS Physician' }],
    dependencyId: 'specialty-select',
  },
  {
    fieldTitle: 'Specialty',
    fieldName: 'Specialty__c',
    id: 'vis-specialty-select',
    type: 'select',
    placeholderText: 'Select a specialty',
    errorMessage: 'Specialty field required.',
    required: true,
    list: specialtyList,
    useNameAsLookupValue: true,
    dependentField: true,
  },
  {
    fieldTitle: 'Comment',
    fieldName: 'mktoCommentCapture',
    id: 'comment',
    type: 'textarea',
    placeholderText: '',
    errorMessage: '',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
];
